const queryKeys = {
  getConfig: "queryKey_getConfig",
  sessionStatus: "queryKey_sessionStatus",
}

export default queryKeys